import apiClient from "./apiClient.js"; 

export default {
  crearSesionDePago() {
    return apiClient.post('/create-checkout-session/');
  },
  verificarEstatusSuscripcion() {
    return apiClient.get('/status/');
  },
  obtenerConfiguracion() {
    return apiClient.get('/configuracion/');
  },
  cancelarSuscripcion() {
    return apiClient.post('/cancel-subscription/');
  }
};